import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Collapse from "@mui/material/Collapse";

function Acclimatation({ index, data, setData }) {
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newData = [...data];
    newData[index][name] = value;
    setData(newData);

    // gestion de la condition (nb >= 7)
    if (name === "acclimatationDays") {
        const numericValue = parseInt(value, 10);
      if (isNaN(numericValue) || numericValue < 7) {
        setError(true);
      } else {
        setError(false);
      }
    }

    if (name === "acclimataiton" && value === "no") {
      setError(false);
    }
  };

  return (
    <div>
      <TextField
        id="experimentDuration"
        name="experimentDuration"
        label="How many days will this experiment last?"
        variant="outlined"
        fullWidth
        sx={{ mb: 2 }}
        value={data[index].experimentDuration || ""}
        onChange={handleChange}
      />
      
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel id="acclimatationLabel">
          If animals are imported from an external provider, specify duration of acclimatation (minimum 7 days). If animals are generated in-house, please select “no acclimatation”
        </FormLabel>
        <RadioGroup
          aria-labelledby="acclimatationLabel"
          name="acclimatation"
          value={data[index].acclimatation || ""}
          onChange={handleChange}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Acclimatation" />
          <FormControlLabel value="no" control={<Radio />} label="No Acclimatation" />
        </RadioGroup>
      </FormControl>

      <Collapse in={data[index].acclimatation === "yes"}>
        <TextField
          id="acclimatationDays"
          name="acclimatationDays"
          label="Days for acclimatation:"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          value={data[index].acclimatationDays || ""}
          onChange={handleChange}
          error={error}
          helperText={error ? "Please enter at least 7 days of acclimatation." : ""}
        />
      </Collapse>
    </div>
  );
}

export default Acclimatation;
